import ContentLoader from 'react-content-loader'

import useContentLoaderColors from '@/lib/theme/useContentLoaderColors'
import VisuallyHidden from '@/utils/a11y/VisuallyHidden'

import style from './StoreCard.module.scss'

export default memo(function StoreCardPlaceholder() {
  const [backgroundColor, foregroundColor] = useContentLoaderColors()
  return (
    <div className={style.Store} role='alert'>
      <VisuallyHidden>Loading the stores...</VisuallyHidden>
      <ContentLoader
        role='progressbar'
        speed={2}
        width={'100%'}
        height={'100%'}
        viewBox='0 0 230 432'
        backgroundColor={backgroundColor}
        foregroundColor={foregroundColor}
      >
        <rect x='0' y='0' rx='4' ry='4' width='230' height='230' />
        <rect x='0' y='238' rx='4' ry='4' width='230' height='20' />
        <rect x='0' y='263' rx='4' ry='4' width='230' height='20' />
        <rect x='0' y='289' rx='4' ry='4' width='230' height='20' />
        <rect x='0' y='315' rx='4' ry='4' width='92' height='32' />
        <rect x='198' y='315' rx='4' ry='4' width='32' height='32' />
        <rect x='0' y='354' rx='4' ry='4' width='230' height='18' />
        <rect x='0' y='378' rx='4' ry='4' width='230' height='18' />
        <rect x='0' y='402' rx='4' ry='4' width='50%' height='18' />
      </ContentLoader>
    </div>
  )
})
